<template>
  <b-container class="contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.destroyheading')}}</h2>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <h4>
          {{$t('site.destroywarning')}}
        </h4>
        <p>
          {{$t('site.destroymessage')}}
        </p>
        <table class="table table--overview">
          <tr>
            <td><strong>{{site.name}}</strong></td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row class="contentcontainer__footer" align-h="end">
      <b-col cols="auto">
        <router-link tag="span" to="/sites" exact>
          <a class="backlink">
            {{$t('site.stopdestroy')}}
          </a>
        </router-link>
        <button v-on:click="localRemove" class="btn btn--danger">
          {{$t('site.confirmdestroy')}}
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import { mapActions, mapMutations } from 'vuex'

export default {

  data () {
    return {
      site: []
    }
  },

  methods: {

    ...mapActions('site', [
      'getSite',
      'removeSite'
    ]),

    ...mapMutations('site', [
      'closeSiteDetailPage'
    ]),

    ...mapMutations('common', [
      'endLoading',
      'resetLoading'
    ]),

    preparePage (data) {
      this.site = data
    },

    localRemove () {
      this.removeSite(this.site.id)
      this.$router.push({
        name: 'dashboard'
      })
    }
  },

  mounted () {
    this.getSite(this.$route.params.id).then(
      response => {
        this.preparePage(response)
        this.endLoading()
        this.closeSiteDetailPage()
      }
    )
  }
}
</script>
